import revive_payload_client_4sVQNw7RlN from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import antd_mx6PWiyNBy from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/plugins/antd.ts";
import expander_client_BAeb2rH54A from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/plugins/expander.client.ts";
import modal_UEFnUXzgTX from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/plugins/modal.ts";
import pdfViewer_client_w7pPxVP5yv from "/Volumes/Tian_SanDisk/DEV/datawang/frontend/plugins/pdfViewer.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  antd_mx6PWiyNBy,
  expander_client_BAeb2rH54A,
  modal_UEFnUXzgTX,
  pdfViewer_client_w7pPxVP5yv
]